import { ReactElement } from "react";
import KeyValueItem from "../../../components/charts/keyValueItem";
import { formatTimeWithSeconds } from "../../../system/utils";
import { IStrandProduction } from "../../../types";
import { getPalette } from "../../../configuration/configuration";
import HtmlTooltip from "../../../components/charts/tooltip";

interface IProps {
  productionItem: IStrandProduction;
  x: number;
  y: number;
  w: number;
  h: number;
  barInMill: number;
}

const ProductionChartMachine = ({ productionItem, x, y, w, h, barInMill }: IProps): ReactElement => {
  return (
    <HtmlTooltip title={
      <div>
        <div className="display-flex-column align-items-center" >
          <strong>{productionItem.machine.name}</strong>
          <strong>{productionItem.title}</strong>
        </div>
        <KeyValueItem name={"Begin"} value={formatTimeWithSeconds(productionItem.beginDatetime as number)} />
        <KeyValueItem name={"End"} value={formatTimeWithSeconds(productionItem.endDatetime as number)} />
        <KeyValueItem name={"Bar in Mill"} value={barInMill.toFixed(1)} unit="min"/>
        <KeyValueItem name={"Heat Number"} value={`${productionItem.heatNumber}`}/>
        <KeyValueItem name={"Steel"} value={productionItem.steelCode}/>
      </div>
    }>
      <rect
        style={{ fill: getPalette().statusColor.production.background }}
        x={x}
        y={y}
        width={w}
        height={h} />
    </HtmlTooltip>
  );
};

export default ProductionChartMachine;
